var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHfill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_15732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8196 5.57803L13.9996 6.40003L13.1756 5.57603C12.1675 4.56808 10.8003 4.00187 9.37472 4.00196C7.94916 4.00205 6.58203 4.56844 5.57407 5.57653C4.56612 6.58462 3.99991 7.95183 4 9.37739C4.00009 10.8029 4.56648 12.1701 5.57457 13.178L13.4696 21.073C13.6102 21.2135 13.8008 21.2924 13.9996 21.2924C14.1983 21.2924 14.3889 21.2135 14.5296 21.073L22.4316 13.176C23.4385 12.1679 24.0039 10.8012 24.0038 9.37632C24.0036 7.95145 23.4377 6.58494 22.4306 5.57703C21.9309 5.07707 21.3377 4.68046 20.6847 4.40987C20.0318 4.13928 19.3319 4 18.6251 4C17.9183 4 17.2184 4.13928 16.5654 4.40987C15.9124 4.68046 15.3192 5.07807 14.8196 5.57803Z",
    fill: "#F31260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8196 5.57803L13.9996 6.40003L13.1756 5.57603C12.1675 4.56808 10.8003 4.00187 9.37472 4.00196C7.94916 4.00205 6.58203 4.56844 5.57407 5.57653C4.56612 6.58462 3.99991 7.95183 4 9.37739C4.00009 10.8029 4.56648 12.1701 5.57457 13.178L13.4696 21.073C13.6102 21.2135 13.8008 21.2924 13.9996 21.2924C14.1983 21.2924 14.3889 21.2135 14.5296 21.073L22.4316 13.176C23.4385 12.1679 24.0039 10.8012 24.0038 9.37632C24.0036 7.95145 23.4377 6.58494 22.4306 5.57703C21.9309 5.07707 21.3377 4.68046 20.6847 4.40987C20.0318 4.13928 19.3319 4 18.6251 4C17.9183 4 17.2184 4.13928 16.5654 4.40987C15.9124 4.68046 15.3192 5.07807 14.8196 5.57803ZM21.3676 12.117L13.9996 19.483L6.63457 12.118C6.2716 11.7589 5.98319 11.3316 5.78591 10.8606C5.58863 10.3897 5.48637 9.88437 5.48501 9.37376C5.48365 8.86316 5.58322 8.35732 5.77799 7.88532C5.97277 7.41332 6.2589 6.98447 6.61996 6.62342C6.98101 6.26236 7.40986 5.97622 7.88186 5.78145C8.35386 5.58668 8.8597 5.48711 9.3703 5.48847C9.88091 5.48983 10.3862 5.59208 10.8572 5.78937C11.3281 5.98665 11.7554 6.27506 12.1146 6.63803L13.4726 7.99503C13.5432 8.06577 13.6273 8.12166 13.7199 8.15943C13.8124 8.1972 13.9116 8.21608 14.0116 8.21496C14.1116 8.21385 14.2103 8.19275 14.302 8.15292C14.3937 8.11309 14.4765 8.05533 14.5456 7.98303L15.8796 6.63803C16.6149 5.95361 17.587 5.58104 18.5914 5.59872C19.5958 5.61639 20.5542 6.02292 21.2649 6.73279C21.9757 7.44266 22.3835 8.40053 22.4024 9.4049C22.4214 10.4093 22.0501 11.3818 21.3666 12.118",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_15732",
    x: -2,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_15732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_15732",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHfill);
export default __webpack_public_path__ + "static/media/hfill.ff8798102ec056d32374ceb5a789a2e0.svg";
export { ForwardRef as ReactComponent };